import { api } from '@/apis';
import { isEmpty, log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function usePersonBoundaryVisits({ boundary, query: filter }) {
  const queryKey = ['personBoundaryVisits', boundary, filter];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const { time, ...match } = filter;

      const featureRequestParams = {
        startTime: time.$gte,
        endTime: time.$lt,
        boundary: boundary,
        ...match,
      };

      log('Read', 'Person Boundary Visits', { boundary, query: filter });

      return api
        .post('boundary-visits/people', {
          json: featureRequestParams,
          signal,
        })
        .json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
    enabled: !!boundary && !isEmpty(filter),
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
